export enum InvoiceExportType {
    /** 0 */
    UNKNOWN_INVOICE_EXPORT_TYPE = 'UNKNOWN_INVOICE_EXPORT_TYPE',
    /** 1 */
    LEGACY = 'LEGACY',
    /** 2 */
    INVOICE = 'INVOICE',
    /** 3 */
    EARLY_PAYMENT = 'EARLY_PAYMENT'
}
